import React, { useEffect, useState } from 'react';
import './index.less';
import SoilWeatherMapComponent from '../weather-query/Component/SoilWeatherMapComponent';
import { SoilCloseIcon, WeatherRightArrowIcon, WeatherScientistIcon } from '@/resource/IconComponentSets';
import { weatherGetRecentQueries, weatherGetSavedQueries, weatherRemoveQuery } from '@/util/Request';
import WeatherQueryRecord from './Component/WeatherQueryRecord';
import { IWeatherStationReqModel, IWeatherStationResModel } from '@/util/Request/requestType';
import { Modal, Spin } from 'antd';
import Copy from 'copy-to-clipboard';
import { useDispatch } from 'react-redux';
import { updateSuccessMessage } from '@/redux/reducer/common';
import { updateSavedQueryId } from '@/redux/reducer/weatherStation';
import { useNavigate } from 'react-router-dom';

const WeatherQueryHistory = () => {
    const dispatch = useDispatch();

    const [queryDatas, setQueryDatas] = useState<IWeatherStationReqModel[]>([]);
    const [recentQueryDatas, setRecentQueryDatas] = useState<IWeatherStationReqModel[]>([]);

    const [mapData, setMapData] = useState<IWeatherStationResModel>();
    const [mapDataIsFetching, setMapDataIsFetching] = useState(false);
    const [queryDataIsFetching, setQueryDataIsFetching] = useState(false);
    const [shareLinkModalShow, setShareLinkModalShow] = useState(false);
    const [currentQueryGuid, setCurrentQueryGuid] = useState('');
    const [recentListExpand, setRecentListExpand] = useState(false);
    const [saveListExpand, setSaveListExpand] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState('');

    const getQueriesHistory = async () => {
        try {
            setQueryDataIsFetching(true);
            const res = await weatherGetSavedQueries();
            const recentRes = await weatherGetRecentQueries();

            setRecentQueryDatas(recentRes);
            setQueryDatas(res);
            setQueryDataIsFetching(false);
        } catch(err) {
            setQueryDataIsFetching(false);
            console.log('err:==', err);
        }
    };

    const shareButtonClicked = async (queryGuid: string) => {
        setCurrentQueryGuid(queryGuid);
        setShareLinkModalShow(true);
    };

    useEffect(() => {
        if (redirectUrl && redirectUrl.length > 0) {
            const element = document.getElementById('redirect-a');
            element.click();
        }
    }, [redirectUrl]);
    const navigate= useNavigate();
    const getMapStationData = async (localQueryId: string, type: 'recent' | 'saved') => {
        // try {
        dispatch(updateSavedQueryId(`${localQueryId}`));
        navigate('/weatherQuery');
    };

    const removeTargetQueryRecord = async (localQueryId: string, type: 'recent' | 'saved') => {
        try {
            setMapDataIsFetching(true);
            const res = await weatherRemoveQuery(localQueryId);
            if (type === 'recent' && res ) {
                const filterRes = recentQueryDatas.filter((queryData) => queryData.queryId !== localQueryId);
                setRecentQueryDatas(filterRes);
            }
            if (type === 'saved' && res) {
                const filterRes = queryDatas.filter((queryData) => queryData.queryId !== localQueryId);
                setQueryDatas(filterRes);
            }
            setMapDataIsFetching(false);
        } catch (err) {
            setMapDataIsFetching(false);
            console.log('err', err);
        }
    };

    useEffect(() => {
        getQueriesHistory();
    }, []);

    return (
        <div className='weather-history-container'>
            <Modal
                open={shareLinkModalShow}
                className={'share-link-in-modal'}
                title={'Share'}
                footer={null}
                onCancel={() => setShareLinkModalShow(false)}
                closeIcon={<SoilCloseIcon />}
            >
                <div className='input-contianer'>
                    <input readOnly value={`${window.location.origin}/weatherQuery/${currentQueryGuid.length > 0 ? currentQueryGuid : ''}`} />
                    <button onClick={() => {
                        Copy(`${window.location.origin}/weatherQuery/${currentQueryGuid}`);
                        dispatch(updateSuccessMessage('Copy url success !'));
                    }}>Copy</button>
                </div>
            </Modal>
            <div className='left-menu'>
                <Spin spinning={queryDataIsFetching}>
                    <div className='title-div'>
                        <h3>My queries</h3>
                    </div>
                    <div className='recent-query-div'>
                        <span>Recent queries</span>
                        <button
                            className='count-span'
                            onClick={() => setRecentListExpand(!recentListExpand)}
                        >
                            {recentQueryDatas.length}
                            <WeatherRightArrowIcon />
                        </button>
                    </div>
                    <div className={`${!recentListExpand && 'zero-height'} `}>
                        {recentQueryDatas.map((data) => (
                            <WeatherQueryRecord
                                key={data.queryId}
                                removeButtonClicked={(queryId) => removeTargetQueryRecord(queryId, 'recent')}
                                displayButtonClicked={() => getMapStationData(data.queryGuid, 'recent')}
                                shareButtonClicked={() => shareButtonClicked(data.queryGuid)}
                                data={data}
                            />
                        ))}
                    </div>
                    <div className='recent-query-div'>
                        <span>Saved queries</span>
                        <button
                            className='count-span'
                            onClick={() => setSaveListExpand(!saveListExpand)}
                        >
                            {queryDatas.length}<WeatherRightArrowIcon />
                        </button>
                    </div>
                    <div className={`${!saveListExpand && 'zero-height'} `}>
                        {queryDatas.map((data) => (
                            <WeatherQueryRecord
                                key={data.queryId}
                                removeButtonClicked={(queryId) => removeTargetQueryRecord(queryId, 'saved')}
                                displayButtonClicked={() => getMapStationData(data.queryGuid, 'saved')}
                                shareButtonClicked={() => shareButtonClicked(data.queryGuid)}
                                data={data}
                            />
                        ))}
                        {
                            queryDatas.length === 0 && (
                                <div className={`${!queryDatas.length && 'weather-empty-div' }`}>
                                    <span>No saved queries yet</span>
                                    <WeatherScientistIcon />
                                </div>
                            )
                        }
                    </div>
                </Spin>
            </div>
            <div className='map-container'>
                <Spin spinning={mapDataIsFetching}>
                    <SoilWeatherMapComponent mapData={mapData?.mapStations} />
                </Spin>
            </div>
            <a id='redirect-a' style={{ display: 'none' }} href={redirectUrl} />
        </div>
    );
};

export default WeatherQueryHistory;